<template>
    <CHeader fixed with-subheader light>
        <CToggler
                in-header
                class="ml-3 d-lg-none"
                @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
                in-header
                class="ml-3 d-md-down-none"
                @click="$store.commit('toggleSidebarDesktop')"
        />

            
        <CHeaderBrand class="mx-auto d-lg-none" to="/">
            <!--      <CIcon name="logo" height="48" alt="Logo"/>-->
            <!--      <h3>MasterKalaERP</h3>-->
            <img src="../assets/img/small.png">

        </CHeaderBrand>


        <CHeaderNav class="mr-auto">
            <CHeaderNavItem class="px-3">
              {{ formattedTime }}
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/dashboard">
                {{ user.name }}
                </CHeaderNavLink>
            </CHeaderNavItem>
          
            <TheHeaderDropdownAccnt/>
        </CHeaderNav>
    </CHeader>
</template>

<script>
    import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

    export default {
        name: 'TheHeader',
        data() {
            return {
                user: {},
                formattedTime: '',
            }
        },
        components: {
            TheHeaderDropdownAccnt
        },
        beforeMount() {
            this.loadCustomerInfo()
        },
        methods: {
            loadCustomerInfo() {
                let finalNavBar = {
                    _name: 'CSidebarNav',
                    _children: []
                };
                this.$http.post(this.$hostname + 'user/info', {}, {
                    headers: {
                        "metoken": localStorage.getItem('token')
                    }
                }).then((response) => {
                    this.user = response.body;


                    var unix_timestamp = this.user.timestamp;
                    localStorage.setItem('masterkala_shop_name', this.user.name);
                    
                    console.log(unix_timestamp);
                    var self = this;
                    setInterval(function(){
                      unix_timestamp++;
                      var date = new Date(unix_timestamp * 1000);
                      var hours = date.getHours();
                      var minutes = "0" + date.getMinutes();
                      var seconds = "0" + date.getSeconds();
                      self.formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                      //console.log(this.formattedTime);

                    }, 1000);



                });
            }
        }
    }
</script>
